import { Component, Input } from "@angular/core";

@Component({
	selector: "body-text",
	template:
		'<p class="app-bodytext" [style.direction]="textDirection" [innerHTML]="text | safeHtml"></p>',
	styles: [".app-bodytext { font-size: 16px;padding-bottom: 12px; }"],
})
export class BodyTextDirective {
	@Input() public text: string;
	@Input() public textDirection: string;
}
